"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAssistedSession = void 0;
const cc_1 = require("../cc");
const types_1 = require("../cc/types");
class MbAssistedSession extends cc_1.MbCCSession {
    constructor() {
        super(...arguments);
        this.isDataValid = (data) => {
            if (data.entrypoint === types_1.EntrypointType.AssistedLogin && data.agentToken) {
                return true;
            }
            return false;
        };
        this.doRefresh = () => {
            throw new Error('method not implemented');
        };
    }
}
exports.MbAssistedSession = MbAssistedSession;
//# sourceMappingURL=index.js.map